import "./App.css";
import { Component } from "react";
import TodoEditor from "./Components/TodoEditor";
import { TodoList } from "./Components/TodoList";
import { Filter } from "./Components/Filter";
import { Info } from "./Components/Info";
import initialTodos from "./Todo.json";

const TODOS_STORAGE_KEY = "todos";

export default class App extends Component {
  state = {
    todos: initialTodos,
    filter: "",
  };

  componentDidMount() {
    const savedTodos = localStorage.getItem(TODOS_STORAGE_KEY);
    if (savedTodos) {
      this.setState({
        todos: JSON.parse(savedTodos),
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.todos !== this.state.todos) {
      localStorage.setItem(TODOS_STORAGE_KEY, JSON.stringify(this.state.todos));
    }
  }

  addTodo = (text) => {
    const newTodo = {
      id: `id-${Date.now()}`,
      text,
      completed: false,
    };

    this.setState((prev) => ({
      todos: [...prev.todos, newTodo],
    }));
  };

  deleteTodo = (id) => {
    this.setState((prev) => ({
      todos: prev.todos.filter((todo) => todo.id !== id),
    }));
  };

  toggleTodoStatus = (id) => {
    this.setState((prev) => ({
      todos: prev.todos.map((todo) =>
        todo.id === id ? { ...todo, completed: !todo.completed } : todo
      ),
    }));
  };

  handleFilterChange = (value) => {
    this.setState({ filter: value });
  };

  render() {
    const visibleTodos = this.state.todos.filter((todo) =>
      todo.text.toLowerCase().includes(this.state.filter.toLowerCase())
    );

    const completedCount = this.state.todos.filter(
      (todo) => todo.completed
    ).length;

    return (
      <div className="container">
        <Info total={this.state.todos.length} completed={completedCount} />
        <TodoEditor onAddTodo={this.addTodo} />
        <Filter
          filterValue={this.state.filter}
          onFilterChange={this.handleFilterChange}
        />
        <TodoList
          todos={visibleTodos}
          onDeleteTodo={this.deleteTodo}
          onToggleTodo={this.toggleTodoStatus}
        />
      </div>
    );
  }
}
